import _ from 'lodash';
import { NOTIFICATION } from '../resourceNames';
import colours from '../../native/config/ol-colours';
import {
  // read
  NOTIFICATION_READ_FETCH_START,
  NOTIFICATION_READ_FETCH_SUCCESS,
  NOTIFICATION_READ_FETCH_FAILURE,
  NOTIFICATION_READ_REFRESH_START,
  NOTIFICATION_READ_REFRESH_SUCCESS,
  NOTIFICATION_READ_REFRESH_FAILURE,
  NOTIFICATION_READ_LOAD_MORE_START,
  NOTIFICATION_READ_LOAD_MORE_SUCCESS,
  NOTIFICATION_READ_LOAD_MORE_FAILURE,
  // unread
  NOTIFICATION_UNREAD_FETCH_START,
  NOTIFICATION_UNREAD_FETCH_SUCCESS,
  NOTIFICATION_UNREAD_FETCH_FAILURE,
  NOTIFICATION_UNREAD_REFRESH_START,
  NOTIFICATION_UNREAD_REFRESH_SUCCESS,
  NOTIFICATION_UNREAD_REFRESH_FAILURE,
  NOTIFICATION_UNREAD_LOAD_MORE_START,
  NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS,
  NOTIFICATION_UNREAD_LOAD_MORE_FAILURE,
  // badge
  UPDATE_UNREAD_NOTIFICATION_BADGE,
  SET_UNREAD_NOTIFICATION_BADGE,
} from './actions';
import Resource from '../../resource/Resource';
import {
  setSegmentDetails,
  trackUserAction,
} from '../Analytics/Segment/dispatchers';
import {
  selectReadNotifications,
  selectUnreadNotifications,
} from './selectors';
import { fetchPreviewUrl } from '../PreviewUrl/dispatchers';
import { makeSelectWhiteLabelInstitution } from '../Institutions/selectors';
import { NOTIFICATION_POST_DETAILS_SCREEN } from '../../ReduxStorage/routeActions';

export function requestNotifications(params, includeRead) {
  return (dispatch, getState) => {
    const whiteLabelInstitution = makeSelectWhiteLabelInstitution(getState());
    const defaultParams = {
      size: 12,
      includeRead,
      includeUnread: !includeRead,
      institution:
        (whiteLabelInstitution &&
          whiteLabelInstitution.get('institutionPath')) ||
        null,
    };
    const newParams = Object.assign({}, defaultParams, params || {});
    return Resource.lookup(NOTIFICATION, 'getNotifications', newParams).then(
      (notificationResult) => {
        return notificationResult;
      }
    );
  };
}

export function fetchNotifications(params, includeRead, action = 'fetch') {
  return (dispatch, getState) => {
    let dispatchObjects = null;
    switch (action) {
      case 'fetch':
        if (includeRead) {
          dispatchObjects = {
            start: NOTIFICATION_READ_FETCH_START,
            success: NOTIFICATION_READ_FETCH_SUCCESS,
            error: NOTIFICATION_READ_FETCH_FAILURE,
          };
        } else {
          dispatchObjects = {
            start: NOTIFICATION_UNREAD_FETCH_START,
            success: NOTIFICATION_UNREAD_FETCH_SUCCESS,
            error: NOTIFICATION_UNREAD_FETCH_FAILURE,
          };
        }
        break;
      case 'refresh':
        if (includeRead) {
          dispatchObjects = {
            start: NOTIFICATION_READ_REFRESH_START,
            success: NOTIFICATION_READ_REFRESH_SUCCESS,
            error: NOTIFICATION_READ_REFRESH_FAILURE,
          };
        } else {
          dispatchObjects = {
            start: NOTIFICATION_UNREAD_REFRESH_START,
            success: NOTIFICATION_UNREAD_REFRESH_SUCCESS,
            error: NOTIFICATION_UNREAD_REFRESH_FAILURE,
          };
        }
        break;
      case 'load':
        if (includeRead) {
          dispatchObjects = {
            start: NOTIFICATION_READ_LOAD_MORE_START,
            success: NOTIFICATION_READ_LOAD_MORE_SUCCESS,
            error: NOTIFICATION_READ_LOAD_MORE_FAILURE,
          };
        } else {
          dispatchObjects = {
            start: NOTIFICATION_UNREAD_LOAD_MORE_START,
            success: NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS,
            error: NOTIFICATION_UNREAD_LOAD_MORE_FAILURE,
          };
        }
        break;
      default:
        break;
    }

    dispatch({
      type: dispatchObjects.start,
    });

    dispatch(requestNotifications(params, includeRead))
      .then((result) => {
        const {
          cursor,
          notificationEvents,
          subscriptions,
          channels,
          users,
          courses,
          cohorts,
          pages,
          comments,
          posts,
          certificates,
          badges,
        } = result;

        // Update badge count
        if (!includeRead && action === 'refresh') {
          dispatch({
            type: UPDATE_UNREAD_NOTIFICATION_BADGE,
            subscriptions: _.values(subscriptions),
            notificationEvents: _.values(notificationEvents),
          });
        }
        dispatch(fetchPreviewUrl(_.values(posts)));
        dispatch({
          type: dispatchObjects.success,
          cursor,
          notificationEvents: _.values(notificationEvents),
          subscriptions: _.values(subscriptions),
          channels: _.values(channels),
          users: _.values(users),
          courses: _.values(courses),
          cohortList: _.values(cohorts),
          pages: _.values(pages),
          comments: _.values(comments),
          posts: _.values(posts),
          certificates: _.values(certificates),
          badges: _.values(badges),
        });

        // Only get include read will have accurate data
        if (action === 'fetch' && includeRead) {
          const unreadNotifications = selectUnreadNotifications(getState());
          const readNotifications = selectReadNotifications(getState());

          dispatch(
            setSegmentDetails('NotificationMenu-Viewed', {
              'interaction.total':
                unreadNotifications.size + readNotifications.size,
              'interaction.read': readNotifications.size,
              'interaction.readIsUnderestimate': unreadNotifications.size > 12,
            })
          );
          dispatch(trackUserAction());
        }
      })
      .catch((error) => {
        dispatch({
          type: dispatchObjects.error,
          error,
        });
      });
  };
}

export function fetchUnreadBadge() {
  return (dispatch) => {
    dispatch(requestNotifications({}, false)).then((unread) => {
      const { subscriptions, notificationEvents } = unread;
      dispatch({
        type: UPDATE_UNREAD_NOTIFICATION_BADGE,
        subscriptions: _.values(subscriptions),
        notificationEvents: _.values(notificationEvents),
      });
    });
  };
}

export function resetNotificationBadge() {
  return (dispatch) => {
    dispatch({
      type: SET_UNREAD_NOTIFICATION_BADGE,
      count: 0,
    });
  };
}

export function navigateToPostDetailsFromNotification(
  notification,
  isFromPushNotification = false
) {
  return (dispatch, getState) => {
    const postId = notification.get('postId');
    const actorId = notification.get('actorId');
    const timestamp = notification.get('eventTime');
    const actionName = notification.get('actionName');
    const formatActionType = false;
    const coursePath = notification.get('coursePath');
    const sourcePath = notification.get('sourcePath');
    const institutionName = notification.get('institutionName');
    const highlightTarget = notification.get('highlightTarget');
    const highlightComment = true;
    const displayMessage = notification.get('displayMessage');
    const scrollToComment = notification.get('scrollToComment');
    const postAuthorId = getState().Posts.getIn(
      ['byId', postId, 'postedBy'],
      ''
    );
    if (!!postId && !!timestamp) {
      dispatch({
        type: NOTIFICATION_POST_DETAILS_SCREEN,
        query: {
          navBarBackgroundColor:
            notification.get('courseThemeColor') || colours.teal,
          contextId: postId,
          actorId,
          postAuthorId,
          timestamp,
          actionName,
          formatActionType,
          coursePath,
          sourcePath,
          institutionName,
          highlightTarget,
          highlightComment,
          displayMessage,
          scrollToComment,
          isFromPushNotification,
        },
      });
    }
  };
}
